/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_Paste_ClipboardInputs */

const vi_tea_purchase_payment_proof_paste_clipboard = /** @type {(inputs: Tea_Purchase_Payment_Proof_Paste_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dán ảnh`)
};

/**

* @param {Tea_Purchase_Payment_Proof_Paste_ClipboardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_paste_clipboard = /** @type {((inputs?: Tea_Purchase_Payment_Proof_Paste_ClipboardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_Paste_ClipboardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_paste_clipboard(inputs)
});